import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import InputIcon from '@mui/icons-material/Input';
import { Edit, Lock } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';

import { commonReducerAction } from 'src/redux/reducers/common';
import { CONSTANTS, STRINGS } from 'src/commons';
import './componentStyle.css';

export default function Collapsable({ open = false, setOpen }) {
  const listItemHover = {
    ':hover': {
      backgroundColor: 'black',
      opacity: '.9',
      color: 'white'
    }
  };
  const listItemHoverDelete = {
    ':hover': {
      backgroundColor: 'red',
      opacity: '.9',
      color: 'white'
    }
  };

  const dispatch = useDispatch();
  const { logoutUser } = commonReducerAction;
  const navigate = useNavigate();
  const Styles = {
    position: 'absolute',
    right: '0',
    background: 'white',
    color: 'black',
    transition: '.5s',
    top: '100%'
  };
  const handleEditProfileClick = (event) => {
    event?.stopPropagation();
    event.preventDefault();
    setOpen(false);
    navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.EDIT_PROFILE);
  };

  const handleChangePasswordClick = (event) => {
    event?.stopPropagation();
    event.preventDefault();
    setOpen(false);
    navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.CHANGE_PASSWORD);
  };

  const handleLogoutClick = (event) => {
    event.stopPropagation();
    dispatch(logoutUser());
    setOpen(false);
    navigate(CONSTANTS.ROUTES.PUBLIC_ROUTES.LOGIN);
  };

  const handleDeleteAdmin = (event) => {
    setOpen(false);
    navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.DELETE_ADMIN);
  };

  return (
    <>
      <Collapse sx={Styles} in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button onClick={handleEditProfileClick} sx={listItemHover}>
            <div className="divIcons">
              <Edit sx={{ height: '20px' }} />
            </div>
            <ListItemText
              primary={STRINGS.EDIT_PROFILE}
              className="listItemText"
            />
          </ListItem>

          <ListItem
            button
            onClick={handleChangePasswordClick}
            sx={listItemHover}
          >
            <div className="divIcons">
              <Lock sx={{ height: '20px' }} />
            </div>
            <ListItemText
              primary={STRINGS.CHANGE_PASSWORD}
              className="listItemText"
            />
          </ListItem>

          <ListItem button onClick={handleLogoutClick} sx={listItemHover}>
            <div className="divIcons">
              <InputIcon style={{ height: '20px' }} />
            </div>

            <ListItemText primary={STRINGS.LOGOUT} className="listItemText" />
          </ListItem>

          <ListItem button onClick={handleDeleteAdmin} sx={listItemHoverDelete}>
            <div className="divIcons">
              <DeleteIcon style={{ height: '20px' }} />
            </div>

            <ListItemText
              primary={STRINGS.DELETE_ADMIN}
              className="listItemText"
            />
          </ListItem>
        </List>
      </Collapse>
    </>
  );
}
